import { useState } from "react";
import { FaCopy } from "react-icons/fa";
import CreateAssign from "./CreateAssign";

const CopyButton = ({ text, label }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (text) {
            navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Сбрасываем статус через 2 сек
        }
    };

    return (
        <button
            className={`btn btn-sm d-flex align-items-center ${copied ? "btn-warning text-dark" : "btn-outline-success"}`}
            onClick={handleCopy}
            disabled={!text} // Отключаем кнопку, если текста нет
        >
            <FaCopy className="me-2"/>{copied ? "Promo Code Copied" : label}
        </button>
    );
};

export default CopyButton;
